import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateEvaluationProvidersInput,
    EvaluationProviders,
    UpdateEvaluationProvidersInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class EvaluationProvidersService {
    private amplifyClient = generateClient();
    constructor() {}

    async listEvaluationProviders(): Promise<EvaluationProviders[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listEvaluationProviders
                })
            ).data.listEvaluationProviders.items;
            if (data) return data as EvaluationProviders[];
        } catch (error) {
            console.error('Error finding EvaluationProviders:', error);
            return null;
        }
    }

    async createEvaluationProviders(
        input: CreateEvaluationProvidersInput
    ): Promise<EvaluationProviders> {
        return this.createRfpProposals(input);
    }

    async createRfpProposals(
        input: CreateEvaluationProvidersInput
    ): Promise<EvaluationProviders> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.createEvaluationProviders,
                    variables: {
                        input
                    }
                })
            ).data.createEvaluationProviders;
            if (data) return data as EvaluationProviders;
        } catch (error) {
            console.error('Error creating EvaluationProviders:', error);
            return null;
        }
    }
    async updateEvaluationProviders(
        input: UpdateEvaluationProvidersInput
    ): Promise<EvaluationProviders> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.updateEvaluationProviders,
                    variables: {
                        input
                    }
                })
            ).data.updateEvaluationProviders;
            if (data) return data as EvaluationProviders;
        } catch (error) {
            console.error('Error creating EvaluationProviders:', error);
            return null;
        }
    }
}
